import { PasswordRuleTypes } from '../types';

class PasswordPolicy {
  ruleType: PasswordRuleTypes;
  value?: number;

  constructor(ruleType: PasswordRuleTypes, value?: string) {
    this.ruleType = ruleType;
    if (value) {
      this.value = Number(value);
    }
  }
}

export { PasswordPolicy };
